// extracted by mini-css-extract-plugin
export default {"blackToastWrapper":"BlackToast_blackToastWrapper__Nw75B","blackToastText":"BlackToast_blackToastText__h8437"};